import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";

interface popupMenuEntryBase {
  label: string;
  onClick?: () => void;
}

interface popupMenuEntryURL extends popupMenuEntryBase {
  url: string;
}
interface popupMenuEntrySub extends popupMenuEntryBase {
  subMenu: popupMenuEntry[];
}
export type popupMenuEntry = popupMenuEntryURL | popupMenuEntrySub;

interface Props {
  label: string;
  entries: popupMenuEntry[];
  onClose?: () => void;
}

export default function SubMenu({ label, entries, onClose }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: Event) => {
    setAnchorEl(event.currentTarget as HTMLElement);
  };
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setAnchorEl(null);
  };

  return (
    <>
      &gt;&nbsp;
      <a onClick={handleClick} href={"#"}>
        {label}
      </a>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {entries.map((entry) => (
          <MenuItem>
            {"url" in entry && (
              <a href={entry.url} onClick={() => handleClose()}>
                {entry.label}
              </a>
            )}
            {"subMenu" in entry && (
              <SubMenu
                label={entry.label}
                entries={entry.subMenu}
                onClose={handleClose}
              />
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
